import React, { useState, useMemo } from "react";
import "./ColumnChart.scss";

const ColumnChart = ({ currentFund, currentPeriod, afps, data }) => {
  const [openTooltip, setOpenTooltip] = useState(false);

  const filterData = useMemo(() => {
    const filterFund = data.filter((fund) => fund.fondo_id === currentFund);
    const filterPeriod = filterFund.filter((period) => period.periodo_id === currentPeriod);
    const listRow = filterPeriod.reduce((total, amount) => {
      if (total.indexOf(amount.orderRow) === -1) {
        total.push(amount.orderRow);
      }

      let totalSort = total.sort((a, b) => a - b);

      return totalSort;
    }, []);

    return listRow.map((item) => {
      const row = filterPeriod.filter((element) => element.orderRow === item);
      const temporalRow = filterPeriod.filter((element) => element.orderRow === item);

      const temporarlOrderArray = temporalRow.sort((a, b) => (
        b.value.substring(0, b.value.length - 1) - a.value.substring(0, a.value.length - 1)
      ));

      let emptyArray = [];

      temporarlOrderArray.forEach((element, index) => {
        if (index === 0) {
          emptyArray.push({
            value: element.value,
            peso: 1,
          });
          element.peso = 1;
        } else {
          emptyArray.find((item, indice) => {
            if (item) {
              if (item.value === element.value) {
                element.peso = item.peso;
              } else {
                emptyArray.push({
                  value: element.value,
                  peso: emptyArray[indice].peso + 1,
                });
                element.peso = emptyArray[indice].peso + 1;
              }
            }
          });
        }

        switch (element.peso) {
          case 5:
            //Plomo
            element.color = "#394D60";
            break;
          case 4:
            //Rojo
            element.color = "#CE2727";
            break;
          case 3:
            //Naranja
            element.color = "#F1692A";
            break;
          case 2:
            //Amarillo
            element.color = "#DBDB45";
            break;
          case 1:
            //Verde
            element.color = "#5AB781";
            break;
          default:
            element.color = "#5AB781";
            break;
        }
      });
      return { row };
    });
  }, [currentFund, currentPeriod, data]);

  return (
    <div className={`hbi-line-chart-vertical`}>
      <div className={`hbi-top-chart`}>
        {afps
          .slice(0)
          .reverse()
          .map((item, index) => (
            <div
              key={index}
              style={{ backgroundColor: item.color }}
              className={`hbi-item-top`}
            >
              <div
                style={{ backgroundColor: item.color }}
                className={`hbi-item-top--absolute`}
              ></div>
            </div>
          ))}
        <div className={`hbi-item-ghost`}></div>
      </div>
      <div className={`hbi-center-chart`}>
        {filterData.map((item, i) => (
          <div key={i} className={`hbi-row`}>
            {item.row
              .slice(0)
              .reverse()
              .map((element, j) => (
                <div
                  key={j}
                  style={{ backgroundColor: element.color }}
                  className={`hbi-colum-item`}
                >
                  {element.value
                    .split("-")
                    .reverse()
                    .join("-")
                    .indexOf("%") === -1
                    ? element.value.split("-").reverse().join("-") + "%"
                    : element.value.split("-").reverse().join("-")}
                </div>
              ))}
            <div className={`hbi-colum-item-ghost`}>{item.row[0].mes}</div>
          </div>
        ))}
      </div>
      <div className={`hbi-bottom-chart`}>
        {afps
          .slice(0)
          .reverse()
          .map((item, index) => (
            <div
              key={index}
              style={{ backgroundColor: item.color }}
              className={`hbi-item-bottom`}
            >
              <div
                style={{ backgroundColor: item.color }}
                className={`hbi-item-bottom--absolute`}
              ></div>
              <div>{item.name}</div>
            </div>
          ))}
        <div className={`hbi-item-ghost`}></div>
      </div>
    </div>
  );
};

export default ColumnChart;